import { MessageToMerchant } from "../remoteAction";

export type ElementMovedAction = MessageToMerchant<"ELEMENT_MOVED", string>;

export type sendElementMovedAction = ElementMovedAction;

export function sendElementMoved(
  event: MouseEvent,
  configName: string,
  newStyle: {
    left: string;
    top: string;
  }
): sendElementMovedAction | null {
  event.stopPropagation();

  return {
    type: "SEND_MESSAGE_TO_MERCHANT",
    payload: {
      type: "ELEMENT_MOVED",
      data: JSON.stringify({ configName, newStyle }),
    },
  };
}
